/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name noticiations
 * @description Fetches the current notification for the current company and displays it.
 */
angular.module('mercury.directives.notifications', [])
.directive('notifications', ["notificationService", function(notificationService) {
  return {
    restrict: 'A',
    templateUrl: 'directives/notifications/notifications.tpl.html',
    link: function(scope) {
      scope.getNotificaionClass = function(level) {
        switch (level) {
          case 0: return 'alert alert-danger';
          case 1: return 'alert alert-warning';
          case 2: return 'alert alert-info';
          case 3: return 'alert alert-success';
        }
      };

      notificationService.GetNotifications().then(function(notice) {
        scope.notificationMessages = notice;
      });

      scope.showNotifications = function() {
        return notificationService.getShowNotifications();
      };

    }
  };
}]);
